import React from 'react';
import { markdownParaBlocos } from '../assistente/markdownBlocos';

// Markdown simples das respostas da IA (sem HTML): parágrafos, listas, negrito, tabela e código.
// Usado pelas Dúvidas do aluno (DuvidaIA) e pela Ajuda com a plataforma (AjudaWidget).

const Trechos = ({ trechos }) => trechos.map((tr, i) => (
  // eslint-disable-next-line react/no-array-index-key
  tr.negrito ? <strong key={i}>{tr.texto}</strong> : <React.Fragment key={i}>{tr.texto}</React.Fragment>
));

const TextoMarkdown = ({ texto, className = 'duvida-ia-texto' }) => (
  <div className={className}>
    {markdownParaBlocos(texto).map((b, i) => {
      const chave = `${b.tipo}-${i}`;
      if (b.tipo === 'titulo') return <p key={chave}><strong><Trechos trechos={b.trechos} /></strong></p>;
      if (b.tipo === 'lista') {
        const Tag = b.ordenada ? 'ol' : 'ul';
        return (
          <Tag key={chave} start={b.ordenada ? b.inicio : undefined}>
            {/* eslint-disable-next-line react/no-array-index-key */}
            {b.itens.map((it, j) => <li key={j}><Trechos trechos={it.trechos} /></li>)}
          </Tag>
        );
      }
      if (b.tipo === 'tabela') {
        return (
          <div key={chave} className="duvida-ia-tabela">
            <table>
              <thead><tr>{b.colunas.map((c, j) => <th key={`${c}-${j}`}>{c}</th>)}</tr></thead>
              {/* eslint-disable-next-line react/no-array-index-key */}
              <tbody>{b.linhas.map((l, j) => <tr key={j}>{l.map((c, k) => <td key={k}>{c}</td>)}</tr>)}</tbody>
            </table>
          </div>
        );
      }
      if (b.tipo === 'codigo') return <pre key={chave}>{b.texto}</pre>;
      if (b.tipo === 'separador') return <hr key={chave} />;
      return <p key={chave}><Trechos trechos={b.trechos} /></p>;
    })}
  </div>
);

export default TextoMarkdown;
